const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Se connecter",
    signUp: "S'inscrire",
    signInShort: "Connexion",
    signUpShort: "Inscription",
  },
  landing: {
    firstMessageBefore: "Vois ",
    firstMessageHighlight: "où tes amis",
    firstMessageAfter: " sont allés aujourd’hui.",
    secondMessageBefore: "Joue avec eux dans le ",
    secondMessageHighlight: "monde réel.",
  },
  search: {
    placeholder: "Rechercher",
    ariaLabel: "Rechercher",
  },
  feed: {
    untitled: "Sans titre",
    channelFallback: "Profil",
    todayMomentsSubtitle: "Découvre où tes amis sont passés aujourd’hui",
    todayMomentsLabel: "Ton Moment",
    friendSpotsSection: "Les spots de tes amis et abonnements",
    spotDistancePrefix: "À",
    loadMoreSpots: "Voir plus",
    nearbyExploreTitle: "Explore autour de toi",
    nearbyTreasureHuntsTitle: "Quêtes IRL",
    treasureHuntLabel: "Quête IRL",
    treasureHuntUnlockOnSite: "Quête IRL à débloquer sur place",
    unlockOnSite: "À débloquer sur place",
    distanceAway: "À {{distance}}",
    mapFoundContent: "Contenu trouvé",
    mapNoExploreFound: "Aucun Explore trouvé",
    openAction: "Ouvrir",
    startAction: "Démarrer",
    trendingNow: "Ils ont la hype en ce moment",
    categoriesTitle: "Catégories",
  },
  video: {
    gameAvailable: "Jeu disponible sur cette vidéo",
    clickToPlay: "Clique pour jouer",
    tapToPlay: "Appuie pour jouer",
    home: "Accueil",
    signInToLike: "Connecte-toi pour liker",
    signInToComment: "Connecte-toi pour commenter",
    exploreOnlyFromMap: "Les Explores s'ouvrent uniquement depuis la map ou leur section dédiée.",
    enableLocationForExplore: "Active ta position pour voir ce contenu Explore.",
    noAnswer: "Aucune réponse",
    youtubeLikesUnavailable: "Likes indisponibles sur les vidéos YouTube",
    addComment: "Ajouter un commentaire...",
    commentsLockedAllAnswered:
      "Les commentaires seront disponibles après avoir répondu au moins une fois à tous les jeux de cette vidéo.",
    commentsLockedAllWon:
      "Les commentaires seront disponibles après avoir gagné au moins une fois à tous les jeux de cette vidéo.",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Question Réponse",
  },
  badges: {
    wood: "Bois",
    bronze: "Bronze",
    silver: "Argent",
    gold: "Or",
    uranium: "Uranium",
  },
  notifications: {
    title: "Notifications",
    loading: "Chargement des notifications...",
    empty: "Aucune notification pour le moment.",
    signInRequired: "Connecte-toi pour voir tes notifications.",
    loadError: "Impossible de charger les notifications.",
    userFallback: "Utilisateur",
  },
  searchFeed: {
    all: "Tout",
    spots: "Spots",
    videos: "Vidéos",
    explores: "Explores",
    treasureHunts: "Quêtes IRL",
    resultsFor: "Résultats pour :",
    noResults: "Aucun résultat trouvé.",
    availableAt: "Disponible à {{distance}}",
    unlockOnSite: "À débloquer sur place",
    channels: "Profils",
  },
  map: {
    filters: {
      subscriptions: "Abonnements",
      private: "Privés",
      all: "Tout",
    },
    myPosition: "Ma position",
    searchPlacePlaceholder: "Cherche Paris, Montmartre...",
    geolocationUnavailable: "Géolocalisation indisponible sur cet appareil.",
    enableLocationNearby: "Autorise la géolocalisation pour débloquer les contenus à proximité.",
    currentPositionUnavailable: "Impossible de récupérer ta position actuelle.",
    googleMapsLoadError: "Google Maps n'a pas pu être chargé.",
    loadExploreSubscriptionsError: "Impossible de charger les follows Explore.",
    loadExplorePointsError: "Impossible de charger les points Explore.",
    loadExploreMapError: "Impossible de charger la carte Explore.",
    loadPointDetailError: "Impossible de charger le détail du point.",
    loadTreasureHuntError: "Impossible de charger cette quête IRL.",
    noPlaceFound: "Aucun lieu trouvé pour cette recherche.",
    placeNotFound: "Lieu introuvable.",
    enableCurrentPositionBeforeSaving: "Active ta position actuelle avant d'enregistrer un point.",
    savePositionError: "Impossible d'enregistrer cette position.",
    positionUsableForContent: "La position peut être utilisée pour du contenu",
    positionSaveFailed: "Position impossible à enregistrer.",
    stopTreasureHuntError: "Impossible d'arrêter cette quête IRL.",
    gpsPointLabelPlaceholder: "Label du point GPS",
  },
  explore: {
    signInToInteract: "Connecte-toi pour interagir avec cet explore.",
    likeError: "Impossible de liker cet explore.",
    addCommentError: "Impossible d'ajouter le commentaire.",
    addReplyError: "Impossible d'ajouter la réponse.",
    likeCommentError: "Impossible de liker ce commentaire.",
    requestSent: "Demande envoyée",
  },
  profileMenu: {
    title: "Profil Qubiq",
    signedOutDescription:
      "Connecte-toi pour accéder à ton profil, à tes notifications et aux fonctions joueur et créateur de Qubiq.",
    myProfile: "Mon profil",
    editProfile: "Modifier mon profil",
    notifications: "Notifications",
    notificationsWithCount: "Notifications ({{count}})",
    friendGroups: "Groupes d'amis",
    inviteFriends: "Inviter mes amis",
    inviteFriendsDesktop: "Inviter mes amis (+20 jetons qubs)",
    createOnQubiq: "Créer sur Qubiq",
    contactUs: "Nous contacter",
    creatorWelcomeTitle: "Tu es maintenant créateur Qubiq 💛",
    creatorWelcomeDesktop:
      "Clique sur le bouton Qubiq Studio pour uploader tes vidéos et Explores, et configurer tes jeux et tes quêtes.",
    creatorWelcomeMobile:
      "Appuie sur le bouton Qubiq Studio pour uploader tes vidéos et Explores, et configurer tes jeux et tes quêtes.",
    contactCreatorMessage:
      "Fais-moi un mail à damien@qubiq.games. Je te réponds au plus vite 💛",
    legalInfo: "Informations légales",
    language: "Langue",
    languageDescription: "Choisis la langue utilisée sur Qubiq.",
    cookiesAndConsent: "Cookies et consentement",
    manageCookies: "Gérer mes cookies",
    openLanguageMenu: "Ouvrir le choix de langue",
  },
  friendGroups: {
    title: "Groupes d'amis",
    subtitle: "Crée ton groupe et invite d'autres joueurs à te rejoindre.",
    signInRequired: "Connecte-toi pour accéder à tes groupes d'amis.",
    loadError: "Impossible de charger les groupes d'amis.",
    detailLoadError: "Impossible de charger ce groupe d'amis.",
    create: "+ Créer un groupe",
    createDialogTitle: "Créer un groupe d'amis",
    renameDialogTitle: "Renommer le groupe",
    groupNameLabel: "Nom du groupe",
    groupNamePlaceholder: "Ex. Team Paris",
    confirmCreate: "Créer le groupe",
    confirmRename: "Enregistrer",
    createError: "Impossible de créer ce groupe.",
    renameError: "Impossible de renommer ce groupe.",
    duplicateNameError: "Ce nom de groupe existe déjà.",
    myGroups: "Mes groupes",
    backToGroups: "Retour aux groupes",
    empty: "Tu n'as pas encore de groupe d'amis.",
    untitledGroup: "Groupe sans nom",
    groupCounts: "{{count}} ami(e)s · {{pending}} demande(s) envoyée(s)",
    incomingInvitesTitle: "Invitations reçues",
    invitedBy: "Invité par {{username}}",
    accept: "Confirmer",
    refuse: "Annuler",
    refuseInviteAction: "Refuser",
    acceptInviteError: "Impossible d'accepter cette invitation.",
    refuseInviteError: "Impossible de refuser cette invitation.",
    selectGroup: "Choisis un groupe",
    selectGroupDescription: "Sélectionne un groupe à gauche pour voir les amis et envoyer de nouvelles invitations.",
    searchUsersTitle: "Ajouter des ami(e)s",
    searchPlayersPlaceholder: "Rechercher des joueurs",
    searchResults: "Résultats",
    searching: "Recherche en cours...",
    noSearchResults: "Aucun utilisateur trouvé.",
    membersTitle: "Membres du groupe",
    noMembersYet: "Aucun membre pour le moment.",
    addUserDialogTitle: "Ajouter à mon groupe d'amis ?",
    addUserDialogBody: "Veux-tu envoyer une invitation à {{username}} ?",
    confirm: "Confirmer",
    cancel: "Annuler",
    inviteError: "Impossible d'envoyer cette invitation.",
    friendStatus: "Ami(e)",
    meLabel: "Moi",
    requestSentStatus: "Demande envoyée",
    incomingInviteDialogTitle: "Rejoindre ce groupe d'amis ?",
    incomingInviteDialogBody: "Veux-tu rejoindre le groupe {{groupName}} ?",
    leaveGroup: "Quitter le groupe",
    leaveDialogTitle: "Quitter le groupe ?",
    leaveDialogBody: "Tu pourras toujours revenir plus tard si quelqu'un te réinvite.",
  },
  inviteFriends: {
    pageTitle: "Invite tes amis",
    popupTitle: "Invite tes amis",
    popupBodyBeforeReward: "Ton ami(e) et toi gagnez",
    popupBodyAfterReward: "quand il ou elle s’inscrit avec ton lien.",
    messageLabel: "Message",
    copyIconLabel: "Copier",
    rewardLine: "20 qubs pour ton ami et 20 qubs pour toi",
    helper:
      "Choisis des contacts si ton appareil le permet. Sinon, Qubiq ouvre le partage de ton device ou copie le message.",
    cta: "Inviter mes amis",
    copyButton: "Copier le message",
    copied: "Message copié",
    loadError: "Impossible de préparer ton lien d'invitation.",
    actionError: "Impossible d'ouvrir l'invitation.",
  },
  cookieConsent: {
    bannerTitle: "Qubiq utilise des cookies",
    bannerDescription:
      "Nous utilisons des traceurs nécessaires au fonctionnement du service et, avec ton accord, des cookies de mesure d’audience pour mieux comprendre l’utilisation de Qubiq.",
    bannerDetails:
      "Tu peux accepter, refuser ou personnaliser tes choix. Refuser est aussi simple qu’accepter, et tu pourras modifier tes préférences plus tard.",
    customize: "Personnaliser",
    refuseAll: "Tout refuser",
    acceptAll: "Tout accepter",
    preferencesTitle: "Gérer mes cookies",
    preferencesDescription:
      "Choisis quels traceurs peuvent être utilisés sur Qubiq. Les cookies nécessaires restent actifs pour permettre la connexion, la sécurité et les fonctions essentielles du service.",
    analyticsNotice:
      "Google Analytics reste désactivé tant que tu n’acceptes pas la mesure d’audience.",
    necessaryTitle: "Cookies nécessaires",
    necessaryDescription:
      "Connexion, sécurité, stabilité de session et fonctions techniques indispensables.",
    analyticsTitle: "Mesure d’audience",
    analyticsDescription:
      "Google Analytics 4 pour mesurer la fréquentation, les performances et l’usage global de Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Catégorie réservée pour de futurs usages marketing. Elle reste désactivée pour le moment.",
    cancel: "Annuler",
    saveChoices: "Enregistrer mes choix",
  },
  navigation: {
    profile: "Profil",
    home: "Accueil",
    infoAndRules: "Infos & règles",
    creatorsShow: "Nos créateurs font le show",
    explore: "Explore",
    rankings: "Classements",
  },
  sidebar: {
    hangout: "Là où tout le monde traîne",
    welcomeCommunity: "Bienvenue dans la commu",
  },
  categories: {
    entertainment: "Divertissement",
    quiz: "Quiz & révisions",
    science: "Vulgarisation scientifique",
    sport: "Sport",
    esport: "ESport",
    music: "Musique",
  },
  visibility: {
    public: "Publié",
    notListed: "Non répertoriée",
    private: "Privé",
  },
  ranking: {
    rankingGeneral: "Classement général",
    progression: "Progression",
    rankings: "Classements",
    exploreRankings: "Classements Explore",
    players: "Joueurs",
    channels: "Profils",
    gameMasters: "Game Masters",
    loading: "Chargement du classement...",
    loadingProgression: "Chargement de la progression...",
    irlQuest: "Quête IRL",
    overall: "Général",
    configLoadError: "Configuration du ranking impossible à charger.",
    leaderboardLoadError: "Classement impossible à charger.",
    exploreLeaderboardLoadError: "Classement Explore impossible à charger.",
    channelLeaderboardLoadError: "Classement des profils impossible à charger.",
    exploreChannelLeaderboardLoadError: "Classement des profils Explore impossible à charger.",
    clientNotFound: "Client introuvable.",
    rankingUserNotFound: "Utilisateur ranking introuvable.",
    progressionLoadError: "Progression impossible à charger.",
    noChannelFound: "Aucun profil trouvé avec ce pseudo.",
    noPlayerFound: "Aucun joueur trouvé avec ce username.",
    searchChannel: "Tu cherches un profil ?",
    searchPlayer: "Tu cherches un profil ?",
    search: "Chercher",
    position: "Position",
    views: "Vues",
    gamesPlayed: "Jeux joués",
    score: "Score",
    level: "Niveau",
    badge: "Badge",
    victories: "Victoires",
    defeats: "Défaites",
    completed: "Terminées",
    currentRank: "Rang actuel",
    progressTo: "Progression vers {{badge}}",
    maxBadgeReached: "Badge maximum atteint",
    remainingXp: "{{count}} XP restants pour atteindre {{badge}}.",
    finalBadgeReached: "Tu as atteint le dernier palier de badge disponible.",
    summary: "Résumé",
    overallRank: "Classement général",
    totalGamesPlayed: "Total parties jouées",
    mostPlayedCategory: "Catégorie la plus jouée",
    completedHunts: "Quêtes terminées",
    segment: "Mode",
    rank: "Classement",
    games: "Parties",
    xpRequired: "XP requis",
    game: "Jeu",
    xpVictory: "XP victoire",
    xpDefeat: "XP défaite",
    hardcoreModeX2: "X2 mode hardcore",
    exploreX2: "X2 Explore",
    timeoutZeroXp: "Timeout 0 XP",
    back: "Retour",
    category: "Catégorie",
    signInToSubscribe: "Connecte-toi pour t'abonner",
    youtubeSubscriptionsUnavailable: "Abonnements indisponibles pour les chaînes YouTube",
    subscriberCount: "{{count}} followers",
    unranked: "Non classé",
    none: "Aucune",
    rules: {
      useCase: "Action",
      reward: "Récompense",
      info: "Règle du jeu",
      gameVictoryLabel: "Victoire Jeu",
      gameVictoryReward: "+215 qubs / +4 XP",
      gameVictoryInfo: "Récompense débloquée une seule fois par jeu.",
      defeatLabel: "Défaite jeu",
      defeatReward: "−1 XP",
      defeatInfo: "Aucun XP perdu si le temps est écoulé.",
      questCompletedLabel: "Quête accomplie",
      questCompletedReward: "+20 XP",
      questCompletedInfo: "Récompense gagnée à chaque quête terminée.",
      creatorGamePlayLabel: "Partie jouée sur ton contenu",
      creatorGamePlayReward: "+5 qubs / +1 XP",
      creatorGamePlayInfo:
        "Récompense gagnée une seule fois par joueur et par jeu, quel que soit le résultat de la partie.",
      exploreLikeReceivedLabel: "Ton Explore a reçu un like",
      exploreLikeReceivedReward: "+1 qub / +1 XP",
      exploreLikeReceivedInfo: "Récompense gagnée une seule fois par utilisateur et par Explore.",
      exploreViewReceivedLabel: "Chaque vue sur ton Explore",
      exploreViewReceivedReward: "+1 qub",
      exploreViewReceivedInfo: "Récompense gagnée pour chaque nouvelle vue sur ton Explore.",
      firstMomentOfDayLabel: "Premier Moment du jour",
      firstMomentOfDayReward: "+50 qubs",
      firstMomentOfDayInfo: "Publie ton premier Moment de la journée pour débloquer ta récompense quotidienne.",
    },
  },
  profile: {
    notFound: "Profil introuvable.",
    loadError: "Impossible de charger ce profil.",
    signInToSubscribe: "Connecte-toi pour t'abonner",
    subscribeFailed: "Le follow a échoué",
    deletePostFailed: "Impossible de supprimer ce post.",
    likePostFailed: "Impossible de liker ce post.",
    updateQubsVisibilityFailed: "Impossible de mettre a jour l'affichage des qubs.",
    videos: "Vidéos",
    explores: "Explores",
    treasureHunts: "Quêtes IRL",
    history: "Historique",
    wallet: "Wallet",
    noVideosWatched: "Aucune vidéo regardée pour l'instant.",
    viewedDuration: "Vu {{duration}}",
    signInToLike: "Connecte-toi pour liker un post.",
    recapGames: "Récap jeux",
    hardcoreRun: "Run hardcore",
    normalRun: "Run normal",
    gamesCount: "{{count}} jeu",
    gamesCount_other: "{{count}} jeux",
    victoriesCount: "{{count}} victoire",
    victoriesCount_other: "{{count}} victoires",
    defeatsCount: "{{count}} défaite",
    defeatsCount_other: "{{count}} défaites",
    gains: "Gains",
    walletDescription: "Bientôt, obtiens des récompenses de nos marques partenaires grâce à tes qubs.",
    noExploreWatched: "Aucun Explore regardé pour l'instant.",
    noTreasureHuntStarted: "Aucune quête IRL démarrée pour l'instant.",
    treasureHuntCompleted: "Terminée",
    treasureHuntInProgress: "En cours",
    treasureHuntStarted: "Démarrée",
    userFallback: "Utilisateur",
    subscribed: "Follower",
    subscribe: "S'abonner",
    subscriberCount: "{{count}} followers",
    levelShort: "Lvl.",
    showQubsTitle: "Montrer mes qubs",
    showQubsDescription: "Affiche ton solde de qubs sur ton profil public.",
    noPostsTitle: "Aucun post pour l'instant",
    noPostsDescription: "Les partages de vidéos et de récapitulatifs de run apparaîtront ici.",
    runOverviewLabel: "Qubiq Run Overview",
    hardcoreGauge: "JAUGE HARDCORE",
    xp: "XP",
    hardcore: "Hardcore",
    normal: "Normal",
    questionAnswer: "Question Réponse",
    victory: "Victoire",
    defeat: "Défaite",
    questionNumber: "Question {{count}}",
    recapPage: "Page récap",
    videoLabel: "Vidéo",
    deletePostTitle: "Supprimer ce post ?",
    deletePostDescription: "Cette action retirera le post de ton profil Qubiq.",
    cancel: "Annuler",
    delete: "Supprimer",
  },
  bannerCounter: {
    loadError: "Impossible de charger le wallet.",
    offline: "hors-ligne",
  },
  studio: {
    explorePublicGpsRequired: "Lie cet Explore à une position GPS avant de le rendre public.",
    explorePrivateGpsRequired: "Lie cet Explore à une position GPS avant d’ajouter des accès privés.",
    title: "",
    createAction: "Créer",
    viewChannel: "Voir mon profil",
    subtitle: "",
    loading: "Chargement...",
    signInRequired: "Connecte-toi pour accéder au Studio.",
    profile: "Modifier mon profil",
    questsAndExplores: "Contenu",
    videos: "Vidéos",
    explores: "Explores",
    exploresDescription:
      "Les Explores sont des vidéos de 3 min que tu peux déposer dans des lieux.\n\nEnregistre ta position GPS et caches-y un Explore ou une étape de Quête IRL.",
    treasureHunts: "Quêtes IRL",
    archives: "Archives",
    statusUploading: "Upload en cours",
    statusProcessing: "Traitement",
    statusReady: "Prête",
    statusError: "Erreur",
    gpsPosition: "Position GPS",
    manageGpsPoints: "Gérer mes points GPS",
    manageGpsPointsDescription: "Retrouve, renomme et supprime les positions GPS enregistrées pour tes Explores.",
    backToExplores: "Retour aux Explores",
    gpsPointSearchPlaceholder: "Rechercher un point GPS par son nom",
    gpsPointLabel: "Nom du point GPS",
    unnamedGpsPoint: "Point GPS sans nom",
    noGpsPoints: "Aucun point GPS enregistré pour le moment.",
    noGpsPointSearch: "Aucun point GPS ne correspond à cette recherche.",
    gpsPointInUse: "Utilisé par {{count}} Explore(s)",
    gpsPointUnused: "Ce point n'est utilisé par aucun Explore.",
    deleteGpsPoint: "Supprimer le point",
    gpsPointDeleteQuestion: "Supprimer définitivement « {{label}} » ?",
    gpsPointDeleteBlocked: "Ce point est utilisé par {{count}} Explore(s). Retire-le de ces Explores avant de le supprimer.",
    loadMoreGpsPoints: "Voir plus de points",
    gpsPointsCount: "{{count}} point(s) GPS",
    gpsMapUnavailable: "La vue Maps est indisponible. Les coordonnées restent affichées ci-dessus.",
    laptop: "Laptop",
    tablet: "Tablette",
    smartphone: "Smartphone",
    durationCheckError: "Impossible de vérifier la durée de cette vidéo.",
    uploadFinishedProcessing: "Upload terminé. Traitement qualité et encodage en cours.",
    verticalPreviewInfo: "Un seul aperçu vertical est affiché pour les Explores.",
    noFileSelected: "Aucun fichier sélectionné",
    profileSaved: "Profil enregistré.",
    profileSaveError: "Profil impossible à enregistrer.",
    loadVideosError: "Impossible de charger les vidéos.",
    loadChannelError: "Impossible de charger le profil.",
    archiveUpdateError: "Impossible de mettre à jour l'archive.",
    loadGpsPositionsError: "Impossible de charger les positions GPS.",
    gpsPositionUsed: "Position GPS utilisée",
    gpsPositionRemoved: "Position GPS supprimée",
    editDetails: "Modifier les détails",
    noAuthorizedEmail: "Tu es seul(e) à avoir accès pour le moment",
    exploreGpsPosition: "Position GPS de ton Explore",
    activeGpsPosition: "Position GPS active",
    removeGpsPosition: "Supprimer la position GPS",
    saving: "Sauvegarde...",
    updating: "Mise à jour...",
    save: "Enregistrer",
    saveGame: "Enregistrer le jeu",
    cancel: "Annuler",
    noGamesConfigured: "Aucun jeu configuré.",
    edit: "Modifier",
    editPhoto: "Modifier la photo",
    savingProfile: "Enregistrement...",
    saveProfile: "Enregistrer",
    noArchivedExplore: "Aucun Explore archivé pour le moment.",
    noArchivedVideo: "Aucune vidéo archivée pour le moment.",
    noArchivedExploreSearch: "Aucun Explore archivé ne correspond à cette recherche.",
    noArchivedVideoSearch: "Aucune vidéo archivée ne correspond à cette recherche.",
    loadingVideos: "Chargement des vidéos...",
    noExploreYet: "Aucun Explore pour le moment.",
    noVideoYet: "Aucune vidéo pour le moment.",
    noExploreSearch: "Aucun Explore ne correspond à cette recherche.",
    noVideoSearch: "Aucune vidéo ne correspond à cette recherche.",
    noDescription: "Aucune description.",
    untitled: "Sans titre",
    viewsCount: "{{count}} vues",
    archiving: "Archivage...",
    confirm: "Confirmer",
    loadingAccess: "Chargement des accès...",
    noLinkedAccount: "Aucun compte lié pour le moment",
    close: "Fermer",
    quizFirstTwoAnswersRequired: "Les deux premières réponses sont obligatoires pour {{game}}.",
    chooseCorrectAnswer: "Choisis la bonne réponse.",
    correctAnswerMustBeFilled: "La bonne réponse doit pointer vers une réponse remplie.",
    shortAnswerRequired: "La bonne réponse est obligatoire pour {{game}}.",
    profilePhotoAlt: "Photo de profil",
    firstName: "Prénom",
    lastName: "Nom",
    username: "Pseudo",
    bio: "Bio",
    statusLabel: "Statut",
    draftStatus: "Brouillon",
    publishedStatus: "Publié",
    treasureHuntPrivateStatus: "Privée",
    treasureHuntPublishedStatus: "Publiée",
    authorizedEmailsLabel: "Emails autorisés",
    authorizedEmailsHelper: "Un email par ligne, ou séparés par des virgules.",
    titleLabel: "Titre",
    categoryLabel: "Catégorie",
    visibilityLabel: "Visibilité",
    descriptionLabel: "Description",
    archivedVideosTab: "Vidéos",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Rechercher une vidéo archivée par son titre",
    archivedExploreSearchPlaceholder: "Rechercher un Explore archivé par son titre",
    videoSearchPlaceholder: "Rechercher une vidéo par son titre",
    exploreSearchPlaceholder: "Rechercher un Explore par son titre",
    removeFromArchives: "Retirer des archives",
    addVideo: "Ajouter une vidéo",
    addExplore: "Ajouter un Explore",
    refresh: "Actualiser",
    archive: "Archiver",
    archiveVideoTitle: "Archiver la vidéo",
    deleteExplore: "Supprimer",
    deleteExploreTitle: "Supprimer définitivement cet Explore ?",
    deleteExploreQuestion: "Cet Explore et ses fichiers seront supprimés définitivement. Cette action est irréversible. Les preuves nécessaires à un signalement éventuel sont conservées selon notre politique de confidentialité.",
    deletingExplore: "Suppression...",
    deletedExplore: "Explore supprimé.",
    deleteExploreError: "Impossible de supprimer cet Explore. Réessaie.",
    deletionErrors: {
      explore_archive_required: "Archive cet Explore avant de le supprimer.",
      explore_processing: "La vidéo est encore en cours de traitement. Réessaie une fois le traitement terminé.",
      explore_not_found: "Cet Explore n'est plus disponible.",
      explore_deletion_unavailable: "La suppression est temporairement indisponible. Réessaie plus tard.",
    },
    archiveVideoQuestion: "Es-tu sûr de vouloir archiver la vidéo ?",
    archiveExploreQuestNotice: "Cet Explore sera aussi retiré de sa quête IRL actuelle.",
    archivedVideoSuccess: "Vidéo archivée.",
    removedFromArchivesSuccess: "Vidéo retirée des archives.",
    searchArchivedThumbnailAlt: "Miniature vidéo",
    thumbnailFallback: "Miniature",
    thumbnailUpdated: "Miniature mise à jour.",
    thumbnailUploadError: "Miniature impossible à uploader.",
    uploadCancelled: "Upload annulé.",
    chooseThumbnail: "Choisis une miniature.",
    chooseImageFormat: "Choisis une image JPG, PNG ou WebP.",
    thumbnailMaxSize: "La miniature doit faire 5 MB maximum.",
    chooseProfilePhoto: "Choisis une photo de profil.",
    profilePhotoMaxSize: "La photo de profil doit faire 5 MB maximum.",
    usernameRequired: "Le nom d'utilisateur est obligatoire.",
    saveChannelError: "Impossible d'enregistrer le profil.",
    verificationCancelled: "Vérification annulée. Le profil n'a pas été modifié.",
    copied: "Copié !",
    copyFailed: "Copie impossible.",
    resolveEmailsError: "Impossible de vérifier les accès privés.",
    loadPrivateAccessError: "Impossible de charger les accès privés.",
    privateAccessTitle: "Accès explore privé",
    configurePrivateAccessTitle: "Configurer les accès privés",
    addEmailsError: "Impossible d'ajouter ces accès.",
    addPrivateAccessUserError: "Impossible d'ajouter cet utilisateur.",
    privateAccessSearchError: "Impossible de rechercher cet utilisateur.",
    privateAccessUserMissingEmail: "Ce compte n'a pas d'email exploitable pour l'accès privé.",
    saveUsernameBeforeUpload: "Enregistre un nom d'utilisateur avant de créer un Explore.",
    chooseVideoToUpload: "Choisis une vidéo à uploader.",
    prepareUploadError: "Impossible de préparer l'upload.",
    uploadToServerError: "Upload vers le serveur impossible.",
    uploadToStorageError: "Upload vers le stockage impossible.",
    storageFailed: "Le stockage de la vidéo a échoué.",
    postUploadPreparationError: "La préparation vidéo après upload a échoué.",
    uploadFailed: "Upload impossible.",
    exploreMaxDuration: "Un Explore doit durer 3 minutes maximum.",
    titleRequired: "Choisis un titre pour enregistrer.",
    gpsPositionRequired: "Choisis une position GPS pour enregistrer.",
    chooseCategory: "Choisis une catégorie.",
    chooseVisibility: "Choisis une visibilité.",
    updateVideoError: "Impossible de modifier la vidéo.",
    videoUpdated: "Vidéo modifiée.",
    videoUpdateFailed: "Modification impossible.",
    assignGpsPositionError: "Impossible d'associer cette position GPS.",
    gpsPositionProximityInfo:
      "Ce contenu ne sera visible que par les utilisateurs qui sont à proximité de cette position GPS.",
    geolocationUnavailable: "La géolocalisation est indisponible sur cet appareil.",
    currentPositionUnavailable: "Impossible de récupérer ta position actuelle.",
    saveCurrentPositionError: "Impossible d'enregistrer la position actuelle.",
    useCurrentPositionError: "Impossible d'utiliser la position actuelle.",
    gpsLabelUpdated: "Label GPS enregistré.",
    gpsLabelUpdateError: "Impossible de modifier ce label.",
    removeGpsPositionError: "Impossible de supprimer la position GPS.",
    gpsPositionRestrictionRemoved:
      "Ce contenu n'est plus réservé aux utilisateurs à proximité de la position GPS.",
    viewVideo: "Voir la vidéo",
    dateLabel: "Date",
    viewsLabel: "Vues",
    changeThumbnail: "Changer la miniature",
    uploadThumbnail: "Upload thumbnail...",
    managePrivateAccess: "Gérer les accès privés",
    treasureHuntPrivateAccessTitle: "Gérer les accès privés",
    treasureHuntPrivateAccessLead: "Tu veux que ta quête reste intime ?",
    treasureHuntPrivateAccessDescription:
      "Donne l'accès uniquement aux utilisateurs de ton choix.",
    privateExploreStatus: "Privé",
    exploreInheritsQuestVisibilityPublished: "Hérite du statut de la quête : Publié",
    exploreInheritsQuestVisibilityPrivate: "Hérite du statut de la quête : Privé",
    authorizedEmailsCount: "{{count}} accès privé(s)",
    addEmails: "Ajouter un ou plusieurs accès",
    add: "Ajouter",
    validate: "Valider",
    privateAccessLead: "Tu veux que ton explore reste intime ?",
    privateAccessDescription:
      "Donne l'accès uniquement aux utilisateurs de ton choix.",
    searchUsersPlaceholder: "Cherche un pseudo",
    searchResults: "Résultats",
    searchingUsers: "Recherche en cours...",
    noPrivateAccessSearchResults: "Aucun utilisateur trouvé.",
    selected: "Sélectionné",
    userFallbackUsername: "utilisateur",
    videoLink: "Lien de la vidéo",
    copyVideoLink: "Copier le lien de la vidéo",
    accountNotFound: "Compte non trouvé",
    unlistedVideoTitle: "Vidéo non répertoriée",
    unlistedVideoDescription:
      "Cette vidéo n'apparaîtra pas dans le feed ni dans les suggestions. Elle sera accessible uniquement via son lien direct.",
    exploreLocationHelp:
      "Les explores sont attachés à un lieu. Seules les personnes qui s'approchent de ton explore pourront l'ouvrir.",
    useGpsPosition: "Position GPS",
    accessRadius: "Rayon d'accès :",
    attachExploreToPlace: "Attache ton explore à un lieu.",
    viewsBeforeDisappearance: "Nombre de vues avant disparition",
    noLimitHelper: "Laisse vide si tu ne veux pas de limite.",
    oneViewPerUser: "Explore visible une fois par utilisateur",
    hiddenExactPosition:
      "Masquer la position exacte jusqu'à 100 m autour de l'explore",
    previewHelp:
      "Vérifie le rendu de la vidéo et des jeux sur laptop, tablette et smartphone.",
    screenPreview: "Aperçu des écrans",
    explorePreview: "Aperçu de l'Explore",
    fullScreen: "Plein écran",
    exitFullScreen: "Quitter le plein écran",
    back: "Retour",
    portraitView: "Vue verticale",
    landscapeView: "Vue horizontale",
    backToMyVideos: "Retour à mes explores",
    preparingVideo: "Préparation vidéo",
    globalLabel: "Global",
    hardcoreMode: "Mode Hardcore",
    hardcoreDescription:
      "En mode hardcore, le joueur double ses gains à chaque bonne réponse. Les gains s'accumulent dans une jauge. Mais évidemment, dès que le joueur fait une erreur il perd tout !",
    understood: "Compris",
    treasureHuntPrefix: "Quête IRL : {{title}}",
    gamesLoadError: "Impossible de charger les jeux.",
    gameScheduleOverlapAt:
      'Avec "Vidéo en pause" désactivé, ce jeu chevauche le jeu programmé à {{time}}.',
    globalPauseDisableError:
      "Impossible de désactiver la pause vidéo globalement : les jeux à {{left}} et {{right}} se chevaucheraient.",
    chooseGameType: "Choisis un type de jeu.",
    invalidGameMoment: "Indique un moment valide au format 00:00 ou 00:00:00.",
    gameEndAfterTimer: "Le timecode de fin doit être supérieur ou égal au timer du jeu.",
    gameMomentWithinDuration:
      "Le moment du jeu doit être compris dans la durée de la vidéo ({{max}} max).",
    gameEndWithinDuration:
      "Le timecode de fin du jeu doit être compris dans la durée de la vidéo ({{max}} max).",
    answerTimePositive: "Indique un temps de réponse supérieur à 0 seconde.",
    gameStartBeforeVideoEnd:
      "Le timecode de début du jeu plus le timer doit se terminer au moins {{margin}} secondes avant la fin de la vidéo ({{max}}), pour laisser le temps à l'animation et au gain.",
    gameMomentWithinDurationShort: "Le moment du jeu doit être compris dans la durée de la vidéo.",
    gameOverlapWithoutPause:
      'Ce jeu chevauche un autre jeu avec la règle "Vidéo en pause" désactivée.',
    videoDurationUnavailable:
      "La durée de la vidéo est indisponible. Attends la fin du traitement avant d'ajouter un jeu.",
    saveGameError: "Impossible d'enregistrer le jeu.",
    gameSaved: "Jeu enregistré.",
    gameSaveFailed: "Jeu impossible à enregistrer.",
    applyGlobalSettingsOverlap:
      "Impossible d'appliquer ces réglages : certains jeux se chevaucheraient.",
    applyGlobalSettingsError: "Impossible d'appliquer les réglages globaux.",
    globalSettingsApplied: "Réglages globaux appliqués.",
    configureGame: "Configurer {{game}}",
    editGame: "Modifier {{game}}",
    gameMoment: "Moment",
    gameStartTimecode: "Timecode de début",
    gameEndTimecode: "Timecode de fin",
    timeFormatHelper: "Utilise 00:00.",
    gameStartsAt: "Le jeu démarre à ce moment.",
    gameEndsAt: "Le jeu se termine à ce moment.",
    answerTime: "Temps pour réponse",
    secondsToAnswer: "secondes pour répondre",
    timecodeReference: "Repère du timecode",
    gameStartReference: "Timecode de début du jeu",
    gameEndReference: "Timecode de fin du jeu",
    question: "Question",
    answerOne: "Réponse 1",
    answerTwo: "Réponse 2",
    answerThree: "Réponse 3",
    answerFour: "Réponse 4",
    correctAnswer: "Bonne réponse",
    expectedAnswer: "Bonne réponse attendue",
    expectedAnswerHelper: "La réponse joueur sera normalisée avant comparaison.",
    successMessage: "Message succès",
    failureMessage: "Message échec",
    globalPauseModeActive: "Config globale active : le mode pause est défini au niveau de la vidéo",
    pauseVideoDuringGame: "Vidéo en pause pendant le jeu",
    hardcoreAnswersGlobal:
      "Mode hardcore actif : les réponses multiples sont définies globalement",
    allowMultipleAnswers: "Autoriser les joueurs à rejouer au jeu",
    hardcoreRegainGlobal: "Mode hardcore actif : le regain est défini globalement",
    enableMultipleAnswersFirst: "Active d'abord les réponses multiples pour autoriser le regain",
    allowRegainEachVictory: "Autoriser le regain sur chaque victoire",
    globalGameConfig: "Config globale pour les jeux de cette vidéo",
    hardcoreWholeVideo: "Mode hardcore sur toute la vidéo",
    pauseAllGames: "Vidéo en pause sur tous les jeux de cette vidéo",
    pauseCannotDisable: "La pause vidéo ne peut pas être désactivée pour le moment.",
    overlappingGamesWithoutPause: "Ces jeux se chevaucheraient sans pause :",
    allowMultipleAnswersAllHardcore:
      "Autoriser plusieurs réponses sur tous les jeux hardcore",
    allowRegainAllHardcore: "Autoriser le regain sur tous les jeux hardcore",
    hardcoreGlobalAllocation:
      "Le mode hardcore force l'allocation globale. Le replay et le regain se règlent ci-dessus.",
    applyToAllGames: "Appliquer à tous les jeux",
    addGame: "Ajouter un jeu",
    removeGameError: "Impossible de supprimer le jeu.",
    removeGameFailed: "Jeu impossible à supprimer.",
    gameDisabled: "Jeu désactivé.",
    disableGame: "Désactiver",
    irlQuestCardLabel: "Quête IRL",
    newTreasureHunt: "Nouvelle quête IRL",
    treasureHuntsLoadError: "Impossible de charger les quêtes IRL.",
    treasureHuntCreated: "Quête IRL créée.",
    treasureHuntSaved: "Quête IRL enregistrée.",
    treasureHuntDeleted: "Quête IRL supprimée.",
    availableExploresLoadError: "Impossible de charger les Explores disponibles.",
    exploresAddedToQuest: "Explores ajoutés à la quête IRL.",
    reorderExploresError: "Impossible de réordonner les Explores.",
    exploreRemovedFromQuest:
      "Explore retiré de la Quête IRL. Il redevient visible sur la Map Explore s'il est public.",
    removeExploreFromQuestError: "Impossible de retirer cet Explore.",
    treasureHuntThumbnailUpdated: "Miniature de la quête mise à jour.",
    configureTreasureHunt: "Sélectionne une quête IRL pour la configurer.",
    treasureHuntName: "Nom de la quête",
    addExistingExplores: "Ajouter des Explores existants",
    noExploreInTreasureHunt: "Aucun Explore dans cette quête IRL pour le moment.",
    noCategory: "Sans catégorie",
    moveUp: "Monter",
    moveDown: "Descendre",
    remove: "Retirer",
    savingTreasureHunt: "Enregistrement...",
    saveTreasureHunt: "Enregistrer la quête",
    delete: "Supprimer",
    treasureHuntsDescription:
      "Les Quêtes IRL sont des parcours d'Explores à réaliser étape par étape.\n\nLes joueurs doivent trouver chaque lieu, et réussir les jeux dans chaque Explore pour débloquer toutes les étapes.",
    createNewExplore: "Créer un nouvel Explore",
    createTreasureHunt: "Créer une quête IRL",
    searchTreasureHunt: "Rechercher une quête par son titre",
    treasureHuntCount: "{{count}} explore(s)",
    noTreasureHuntYet: "Aucune quête IRL pour le moment.",
    noTreasureHuntSearch: "Aucune quête IRL ne correspond à cette recherche.",
    signInToStartTreasureHunt: "Connecte-toi pour démarrer la quête.",
    replayable: "Rejouable",
    oneAttempt: "Une tentative",
    addExistingExploresTitle: "Ajouter des Explores existants",
    outsideMapWarning:
      "Les explores déjà liés à une autre quête IRL seront retirés de leur quête actuelle.",
    loadingAvailableExplores: "Chargement des Explores disponibles...",
    noAvailableExplore: "Aucun Explore disponible à ajouter.",
    deleteTreasureHuntTitle: "Supprimer la quête",
    deleteTreasureHuntDescription:
      "Cette action supprime définitivement la quête IRL, sans supprimer les Explores associés.",
    deleting: "Suppression...",
  },
  videoDetail: {
    sharePrivateDisabled: "Le partage des vidéos privées est désactivé.",
    signInToPostProfile: "Connecte-toi pour publier sur ton profil.",
    publishedOnProfile: "Publié sur ton profil.",
    shared: "Partagé !",
    linkCopiedOpenApp: "Lien copié. Ouvre l’app pour coller le lien.",
    shareFailed: "Partage impossible.",
    copySuccess: "Copié !",
    copyFailed: "Copie impossible.",
  },
  languageDialog: {
    title: "Langue",
    description:
      "Choisis la langue utilisée sur Qubiq. Si la langue du navigateur n'est pas prise en charge, l'application utilise l'anglais.",
    close: "Fermer",
  },
  legalLinks: {
    terms: "Conditions",
    legal: "Mentions légales",
    privacy: "Confidentialité",
    cookies: "Cookies",
    moderation: "Modération",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
